'use strict';

/*
 * @ngdoc function
 * @name cimerFrontEndApp.service:SurveyService
 * @description
 * #SurveyService
 * Service of the cimerFrontEndApp
 */
angular.module('cimerFrontEndApp').service('SurveyService', ['$q','$http','$window','ApiUrl',
    function ($q, $http, $window, ApiUrl) {

        var _apiUrl = ApiUrl.url('/Survey/');
        var _emptyPromptId = 55; //Id for promptless (non-matrix style) groupings
        var _emptyScaleAnswerId = 143; //Id for text, non-scale answers in Survey Answers


        ///////// BUILD SURVEY FOR VIEWING: incorporate answer dictionary into Survey display object
        var _buildSurveyDisplayObject = function (surveyObj, answerDict, forSurveyTaker) {

            var returnObj = {
                SurveyID: surveyObj.SurveyID,
                TargetID: surveyObj.TargetID,
                Name: surveyObj.Name,
                InfoText: surveyObj.InfoText,
                EmailText: surveyObj.EmailText,
                BaseSurveyID: surveyObj.BaseSurveyID,
                Sections: []
            };

            var countQuestions = 0; //count total number of questions
            var questionCount = 1; //for labeling questions, each matrix counts as one question at this level (questionCount.promptCount - ex 1.4)

            for (var sectionIx = 0; sectionIx < surveyObj.Sections.length; sectionIx++) {
                var section = surveyObj.Sections[sectionIx];

                var tempSection = {
                    SectionID: section.SectionID,
                    SectionTitle: section.SectionTitle,
                    SectionText: section.SectionText,
                    SectionSortOrder: section.SectionSortOrder,
                    SectionRoleID: section.SectionRoleID,
                    Validated: section.Validated,
                    QuestionPrompts: [],
                    MoreInformation: section.MoreInformation,
                    Projects: section.Projects,
                    Tags: section.Tags
                };

                for (var promptIx = 0; promptIx < section.QuestionPrompts.length; promptIx++) {
                    var questionPrompt = section.QuestionPrompts[promptIx];
                    var answer;
                    var question;
                    var questionIx;
                    //need to treat questions grouped under the 'no-prompt' PromptID separately
                    if (questionPrompt.QuestionPromptID === _emptyPromptId) {
                        //process and add each question individually to 'QuestionPrompts' array of this section
                        for (questionIx = 0; questionIx < questionPrompt.Questions.length; questionIx++) {
                            question = questionPrompt.Questions[questionIx];
                            question.canShowQuestion = true;  // default this to true because unless we are survey taker, we want to see all the questions. This gets updated later for a survey taker

                            //if this question has an answer in the dictionary
                            if (answerDict.hasOwnProperty(question.SectionIndexID)) {
                                //if not multi-select, use the first (and only) answer
                                if (question.QuestionTypeID !== 4) {
                                    answer = answerDict[question.SectionIndexID][0]; //since it's not multi-select, use first ix

                                    question['Answer'] = answer.ScaleAnswerID;
                                    question['AnswerText'] = answer.AnswerText;
                                    question['SurveyAnswerID'] = answer.SurveyAnswerID;
                                    question['OtherAnswerText'] = answer.OtherAnswerText;
                                }
                                else { //it's multi-select
                                    var answers = answerDict[question.SectionIndexID];
                                    question['MultiSelectAnswers'] = {};

                                    for (var i = 0; i < answers.length; i++) {
                                        question['MultiSelectAnswers'][answers[i].ScaleAnswerID] = {
                                            Answer: answers[i].ScaleAnswerID,
                                            AnswerText: answers[i].AnswerText,
                                            SurveyAnswerID: answers[i].SurveyAnswerID,
                                            Checked: true,
                                            OtherAnswerText: answers[i].OtherAnswerText
                                        };
                                    }
                                }
                            }

                            tempSection.QuestionPrompts.push(question);
                            countQuestions++; //1 per matrix prompt

                        } // end question loop 1

                    }

                    else { //otherwise parse all the matrix/table questions (grouped)
                        var promptCount = 1;
                        var tempPrompt = {
                            QuestionPromptID: questionPrompt.QuestionPromptID,
                            QuestionPromptText: questionPrompt.QuestionPromptText,
                            QuestionPromptTextPlain: questionPrompt.QuestionPromptTextPlain,
                            Questions: [],
                            canShowQuestion: true  // default this to true because unless we are survey taker, we want to see all the questions. This gets updated later for a survey taker
                        };

                        for (questionIx = 0; questionIx < questionPrompt.Questions.length; questionIx++) {
                            question = questionPrompt.Questions[questionIx];
                            question.promptCount = promptCount;
                            promptCount++;

                            //if this question has an answer in the dictionary
                            if (answerDict.hasOwnProperty(question.SectionIndexID)) {
                                answer = answerDict[question.SectionIndexID][0]; //since it's not multi-select, use first ix

                                question['Answer'] = answer.ScaleAnswerID;
                                question['AnswerText'] = answer.AnswerText;
                                question['SurveyAnswerID'] = answer.SurveyAnswerID;
                            }
                            tempPrompt.Questions.push(question);
                            countQuestions++;
                        }

                        //add last row of matrix/table sortby value to the prompt object for sorting
                        tempPrompt.SortOrder = tempPrompt.Questions[tempPrompt.Questions.length - 1].SortOrder;

                        tempSection.QuestionPrompts.push(tempPrompt);
                    } //end parse matrix/table

                }

                //sort all of the questions in the Section before adding to returnObj
                tempSection.QuestionPrompts.sort(function (a, b) {
                    return a.SortOrder - b.SortOrder;
                });
                if (!forSurveyTaker) {  // non-survey takers will see all the questions, so assign numbers now
                    //and assign questionCount after they've been sorted
                    for (var p = 0; p < tempSection.QuestionPrompts.length; p++) {
                        tempSection.QuestionPrompts[p].questionCount = questionCount;
                        questionCount++;
                    }
                }

                returnObj.Sections.push(tempSection);

            } //end section loop

            // if this is someone actually taking the survey, break up the survey further to account for display logic
            if (forSurveyTaker) {
                returnObj = _buildSurveyWithDisplayLogic(returnObj);
                // assign question numbers to the first section now that the display logic is broken up
                for (var j = 0; j < returnObj.Sections[0].QuestionPrompts.length; j++) {
                    returnObj.Sections[0].QuestionPrompts[j].questionCount = questionCount;
                    questionCount++;
                }
            }
            returnObj.numQuestions = countQuestions;
            return returnObj;
        };

        ///////// HELPERS 
        //get answer info for radio/multi-select
        var getNonTextAnswerHelper = function (question, answerReturnObj, selectedAnswerId) {
            var answerScale = question.QuestionScale.filter(function (obj) {
                return obj.ScaleAnswerID === selectedAnswerId;
            })[0];

            var text = '',
                answerNumber = 0,
                answerID = _emptyScaleAnswerId;
            if (answerScale) {
                text = answerScale.AnswerText;
                answerNumber = answerScale.AnswerNumber;
                answerID = answerScale.ScaleAnswerID;
            }

            answerReturnObj.Answer = answerNumber;
            answerReturnObj.AnswerText = text;
            answerReturnObj.ScaleAnswerID = answerID;

            return answerReturnObj;
        };

        //get answer info for single-select non-text question
        var getNonTextAnswer = function (question, answerObj) {
            answerObj.OtherAnswerText = question.OtherAnswerText;
            return getNonTextAnswerHelper(question, answerObj, question.Answer);
        };
        //get answer info for multi-select
        var getMultiSelectAnswer = function (question, answerObj, selectedAnswer) {
            answerObj.OtherAnswerText = question.MultiSelectAnswers[selectedAnswer].OtherAnswerText;
            return getNonTextAnswerHelper(question, answerObj, parseInt(selectedAnswer));
        };

        //get answer for free-text question
        var getTextAnswer = function(question, answerObj) {
            answerObj.Answer = 0; //no scale for free text
            answerObj.AnswerText = question.AnswerText;
            answerObj.ScaleAnswerID = _emptyScaleAnswerId;

            return answerObj;
        };


        ///////// BUILD SURVEY FOR SAVING
        var _buildSurveySubmissionArray = function (surveyObj) {
            var submitArr = [];
            var numQuestionsAnswered = 0;

            for (var sectionIx = 0; sectionIx < surveyObj.Sections.length; sectionIx++) {
                var section = surveyObj.Sections[sectionIx];
                if (!section.IsParentSection) {
                    section = _calculateCanShowChildSection(section, surveyObj);
                }
                if (!section.canShowSection) { // don't add sections that are not reachable to the submission array
                    continue;
                }
                for (var promptIx = 0; promptIx < section.QuestionPrompts.length; promptIx++) {
                    var prompt = section.QuestionPrompts[promptIx];
                    if (!prompt.canShowQuestion) { // don't add questions that are not reachable to the submission array
                        continue;
                    }

                    //need to treat individual questions and matrix/table questions separately
                    //individual question (not matrix)
                    var answerObj = {};
                    var question;
                    if (!prompt.hasOwnProperty('QuestionPromptID')) {
                        question = prompt;
                        answerObj.SectionIndexID = question.SectionIndexID;

                        //if single-select is already answered, attach DB id of answer
                        if (question.hasOwnProperty('SurveyAnswerID')) {
                            answerObj.SurveyAnswerID = question.SurveyAnswerID;
                        }

                        // --- Parse Various Question types ---
                        // --- only submit if there is an answer ---
                        //open ended/text
                        if (question.QuestionTypeID === 3 && question.hasOwnProperty('AnswerText') && question.AnswerText !== '') {
                            submitArr.push(getTextAnswer(question, answerObj));
                            numQuestionsAnswered++;
                        }
                        //multi-select
                        else if (question.QuestionTypeID === 4 && question.hasOwnProperty('MultiSelectAnswers') && question.MultiSelectAnswers !== null) {
                            var numChecked = 0;
                            //add each multi-select answer
                            Object.keys(question.MultiSelectAnswers).forEach(function (key) {
                                var answer = question.MultiSelectAnswers[key];
                                if (answer.Checked) { //if the answer is checked, add it to the list of answers
                                    numChecked++;
                                    var multiAnswerObj = {};
                                    multiAnswerObj.SectionIndexID = question.SectionIndexID;

                                    if (answer.hasOwnProperty('SurveyAnswerID')) //add database id if row already exists
                                        multiAnswerObj.SurveyAnswerID = answer.SurveyAnswerID;

                                    submitArr.push(getMultiSelectAnswer(question, multiAnswerObj, key));
                                }
                            });
                            if (numChecked > 0)
                                numQuestionsAnswered++; //mark that question as having been answered
                        }
                        //radio etc
                        else if (question.hasOwnProperty('Answer') && question.Answer !== 0) {
                            submitArr.push(getNonTextAnswer(question, answerObj));
                            numQuestionsAnswered++;
                        }

                    }

                    //matrix/table
                    else { 
                        for (var questionIx = 0; questionIx < prompt.Questions.length; questionIx++) {
                            answerObj = {};
                            question = prompt.Questions[questionIx];
                            answerObj.SectionIndexID = question.SectionIndexID;

                            //if already answered, attach DB id of answer
                            if (question.hasOwnProperty('SurveyAnswerID')) {
                                answerObj.SurveyAnswerID = question.SurveyAnswerID;
                            }
                            // --- Parse Various Question types ---
                            // --- only submit if there is an answer ---
                            //radio button
                            if (question.QuestionTypeID === 1 && question.hasOwnProperty('Answer') && question.Answer !== 0) {
                                submitArr.push(getNonTextAnswer(question, answerObj));
                                numQuestionsAnswered++;
                            }

                            //open ended/text
                            if (question.QuestionTypeID === 3 && question.hasOwnProperty('AnswerText') && question.AnswerText !== '') {
                                submitArr.push(getTextAnswer(question, answerObj));
                                numQuestionsAnswered++;
                            }
                        }
                    } // end else

                } // end question prompt loop
            } //end section loop


            var returnObj = {
                count: numQuestionsAnswered,
                answers: submitArr
            };

            return returnObj;
        };

        var _buildCompositeScoreArray = function (surveyObj) {
            var returnObj = {
                SurveyID: surveyObj.SurveyID,
                SectionID: surveyObj.SectionID,
                Name: surveyObj.Name,
                CompositeScores: []
            };

            for (var compScoreIx = 0; compScoreIx < surveyObj.CompositeScores.length; compScoreIx++) {
                var compositeScore = surveyObj.CompositeScores[compScoreIx];
                var tempCompositeScore = {
                    Name: compositeScore.Name,
                    CompositeScoreID: compositeScore.CompositeScoreID,
                    AllQuestions: [],
                    SelectedQuestions: []
                };

                for (var sectionIx = 0; sectionIx < compositeScore.Sections.length; sectionIx++) {
                    var section = compositeScore.Sections[sectionIx];

                    for (var promptIx = 0; promptIx < section.QuestionPrompts.length; promptIx++) {
                        var questionPrompt = section.QuestionPrompts[promptIx];
                        //process and add each question individually
                        for (var questionIx = 0; questionIx < questionPrompt.Questions.length; questionIx++) {
                            var question = questionPrompt.Questions[questionIx];
                            // matrix prompts need to have the question prompt added to the question text
                            if (questionPrompt.QuestionPromptID !== _emptyPromptId) {
                                question.TextPlain = question.TextPlain + ': ' + questionPrompt.QuestionPromptTextPlain;
                            }
                            // mark the question as selected if it is already in the list of questions for the composite score
                            question.Selected = false;
                            for (var selectedIx = 0; selectedIx < compositeScore.Questions.length; selectedIx++) {
                                if (question.QuestionID === compositeScore.Questions[selectedIx].QuestionID) {
                                    question.Selected = true;
                                    tempCompositeScore.SelectedQuestions.push(question);
                                    break;
                                }
                            }
                            tempCompositeScore.AllQuestions.push(question);
                        } 
                    } //end question prompts
                } //end section loop
                returnObj.CompositeScores.push(tempCompositeScore);
            } //end composite scores loop

            return returnObj;
        };

        var _buildCompositeScoreAllQuestionsList = function (sections){
            var tempQuestions = [];
            for (var sectionIx = 0; sectionIx < sections.length; sectionIx++) {
                var section = sections[sectionIx];

                for (var promptIx = 0; promptIx < section.QuestionPrompts.length; promptIx++) {
                    var questionPrompt = section.QuestionPrompts[promptIx];
                    //process and add each question individually
                    for (var questionIx = 0; questionIx < questionPrompt.Questions.length; questionIx++) {
                        var question = questionPrompt.Questions[questionIx];
                        // matrix prompts need to have the question prompt added to the question text
                        if (questionPrompt.QuestionPromptID !== _emptyPromptId) {
                            question.TextPlain = question.TextPlain + ': ' + questionPrompt.QuestionPromptTextPlain;
                        }
                        tempQuestions.push(question);
                    }
                } //end question prompts
            } //end section loop
            return tempQuestions;
        };

        var _buildSurveyWithDisplayLogic = function (surveyObj) {
            var returnObj = {
                SurveyID: surveyObj.SurveyID,
                TargetID: surveyObj.TargetID,
                Name: surveyObj.Name,
                InfoText: surveyObj.InfoText,
                EmailText: surveyObj.EmailText,
                BaseSurveyID: surveyObj.BaseSurveyID,
                Sections: []
            };
            var sectionNumber = 0;
            // break up the existing sections further for display logic
            // questions will be put into additional sections in the following manner:
            //      parent questions will be added to the same section until a child question is reached
            //      questions without question branches will be treated as parent questions for the purposes of display
            //      child questions will be added to the same section until a parent question is reached
            for (var sectionIx = 0; sectionIx < surveyObj.Sections.length; sectionIx++) {
                var section = surveyObj.Sections[sectionIx];
                var currentSection = _newSection(section, true, sectionNumber); // the first question in any section has to be a parent question so the first section will always be a parent section
                sectionNumber++;
                for (var promptIx = 0; promptIx < section.QuestionPrompts.length; promptIx++) {
                    var questionPrompt = section.QuestionPrompts[promptIx];
                    // Get the question, all questions in a matrix are either parent or child so we only need to check the first one
                    var question = questionPrompt.hasOwnProperty('QuestionPromptID') ? questionPrompt.Questions[0] : questionPrompt;
                    if (question.QuestionBranches && question.QuestionBranches.length !== 0) {
                        if (currentSection.IsParentSection) { // child questions need a new section so push the parent section
                            returnObj.Sections.push(currentSection);
                            currentSection = _newSection(section, false, sectionNumber); // make a new temp section for the child questions
                            sectionNumber++;
                        }                        
                        currentSection.QuestionPrompts.push(questionPrompt);
                    }
                    else {  // we are going to treat a question with no child question branches a parent question for purposes of building our display
                        if (!currentSection.IsParentSection) { // parent questions need a new section so push the child section
                            returnObj.Sections.push(currentSection);
                            currentSection = _newSection(section, true, sectionNumber); // make a new temp section for the parent questions
                            sectionNumber++;
                        } 
                        currentSection.QuestionPrompts.push(questionPrompt);
                    }
                }
                // push the last section
                returnObj.Sections.push(currentSection);
            }
            // force a final section that says to submit in case the last section is a child section and we don't visit
            var finalSection = {
                SectionID: null,
                SectionTitle: null,
                SectionText: 'You have completed this survey. Click submit to finalize.',
                SectionSortOrder: null,
                SectionRoleID: null,
                Validated: null,
                QuestionPrompts: [],
                IsParentSection: true,
                canShowSection: true,
                sectionNumber: sectionNumber
            };
            returnObj.Sections.push(finalSection);
            returnObj.totalNumberOfSections = sectionNumber;
            return returnObj;
        };

        var _calculateCanShowChildSection = function (section, survey) {
            section.canShowSection = false;
            for (var promptIx = 0; promptIx < section.QuestionPrompts.length; promptIx++) {
                var question = section.QuestionPrompts[promptIx];
                if (question.hasOwnProperty('QuestionPromptID')) { // need to retrieve the object from another place if it is a matrix question
                    question = question.Questions[0]; // all questions in a matrix have the same logic so we only need to check the first one
                }
                section.QuestionPrompts[promptIx].canShowQuestion = false; // default to not showing
                for (var qbIx = 0; qbIx < question.QuestionBranches.length; qbIx++) { // loop over all question branches which show this question
                    var childQuestionBranch = question.QuestionBranches[qbIx];
                    for (var questionIx = 0; questionIx < childQuestionBranch.ParentQuestions.length; questionIx++) { // loop over all parent questions in the branch
                        if (_questionBranchSatisfied(childQuestionBranch.ParentQuestions[questionIx], survey)) {
                            section.QuestionPrompts[promptIx].canShowQuestion = true;
                            section.canShowSection = true;
                        }
                    }
                }
            }
            return section;
        };

        var _newSection = function (section, isParentSection, sectionNumber) {
            var newSection = {
                SectionID: section.SectionID,
                SectionTitle: section.SectionTitle,
                SectionText: section.SectionText,
                SectionSortOrder: section.SectionSortOrder,
                SectionRoleID: section.SectionRoleID,
                Validated: section.Validated,
                QuestionPrompts: [],
                IsParentSection: isParentSection,
                canShowSection: isParentSection,  // this will be calculated for child sections later
                sectionNumber: sectionNumber
            };
            return newSection;
        };

        var _questionBranchSatisfied = function (parentQuestionBranch, survey) {
            // find the parent question and answers in the survey
            for (var sectionIx = 0; sectionIx < survey.Sections.length; sectionIx++) {
                if (!survey.Sections[sectionIx].IsParentSection) {
                    continue;  // not a parent section, don't need to look at it
                }
                for (var promptIx = 0; promptIx < survey.Sections[sectionIx].QuestionPrompts.length; promptIx++) {
                    var parentQuestion = survey.Sections[sectionIx].QuestionPrompts[promptIx];
                    if (parentQuestion.QuestionTypeID !== 1 && parentQuestion.QuestionTypeID !== 4) {  // only single and multi select questions can be parents
                        continue;
                    }
                    if (parentQuestion.QuestionID === parentQuestionBranch.ParentQuestionID) {  // this is the current parent question
                        if (parentQuestion.QuestionTypeID === 1) {  // single select
                            for (var i = 0; i < parentQuestionBranch.ScaleAnswers.length; i++) {
                                if (parentQuestion['Answer'] === parentQuestionBranch.ScaleAnswers[i].ScaleAnswerID) {
                                    return true;
                                }
                            }

                        }
                        else if (parentQuestion.QuestionTypeID === 4) {  // multi-select
                            for (var j = 0; j < parentQuestionBranch.ScaleAnswers.length; j++) {
                                if (parentQuestion['MultiSelectAnswers']) {
                                    var answer = parentQuestion['MultiSelectAnswers'][parentQuestionBranch.ScaleAnswers[j].ScaleAnswerID];
                                    if (answer && answer.Checked) {
                                        return true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return false;
        };

        var _parseQuestionScales = function (scaleArray) {

            var outArray = [];
            for (var i = 0; i < scaleArray.length; i++) {
                if (scaleArray[i].hasOwnProperty('Answers') && scaleArray[i].Answers.length > 1) { //skip open ended question
                    outArray.push(scaleArray[i]);
                }
            }
            return outArray;
        };

        //Survey Service Public API is below
        return {

            //get survey object - DISPLAY ONLY
            getSurvey: function (surveyID) {
                var deferred = $q.defer();

                $http.get(_apiUrl + 'GetSurvey/' + surveyID).then(function (response) {
                    deferred.resolve(_buildSurveyDisplayObject(response.data, [], false));
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;

            },

            //get survey object for editing
            getSurveyForEdit: function (surveyID) {
                var deferred = $q.defer();

                $http.get(_apiUrl + 'GetSurveyForEdit/' + surveyID).then(function (response) {
                    deferred.resolve(_buildSurveyDisplayObject(response.data, [], false));
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },

            //get survey for copying
            getSurveyForCopy: function(surveyID) {
                var deferred = $q.defer();

                $http.get(_apiUrl + 'GetSurveyForEdit/' + surveyID).then(function (response) {
                    var survey = _buildSurveyDisplayObject(response.data, [], false);

                    //strip ids here
                    survey.SurveyID = null; 
                    survey.BaseSurveyID = null;
                    survey.Name = survey.Name + " - copy";
                    for (var i = 0; i < survey.Sections.length; i++) {
                        survey.Sections[i].SectionID = null;
                        for (var j = 0; j < survey.Sections[i].QuestionPrompts.length; j++) {
                            if (survey.Sections[i].QuestionPrompts[j].hasOwnProperty("Questions")) { //its a matrix question, need another loop	
                                survey.Sections[i].QuestionPrompts[j].QuestionPromptID = null;
                                for (var k = 0; k < survey.Sections[i].QuestionPrompts[j].Questions.length; k++) {
                                    survey.Sections[i].QuestionPrompts[j].Questions[k].QuestionID = null;
                                    survey.Sections[i].QuestionPrompts[j].Questions[k].SectionIndexID = null;
                                    survey.Sections[i].QuestionPrompts[j].Questions[k].QuestionScaleID = null;
                                    survey.Sections[i].QuestionPrompts[j].Questions[k].QuestionBranches = [];
                                    for (var l = 0; l < survey.Sections[i].QuestionPrompts[j].Questions[k].QuestionScale.length; l++) {
                                        survey.Sections[i].QuestionPrompts[j].Questions[k].QuestionScale[l].ScaleAnswerID = null;
                                        survey.Sections[i].QuestionPrompts[j].Questions[k].QuestionScale[l].QuestionBranchID = null;
                                    }
                                }
                            } else { //normal question	
                                survey.Sections[i].QuestionPrompts[j].QuestionID = null;
                                survey.Sections[i].QuestionPrompts[j].SectionIndexID = null;
                                survey.Sections[i].QuestionPrompts[j].QuestionBranches = [];
                                // only clear IDs for non-text questions
                                if (survey.Sections[i].QuestionPrompts[j].QuestionScaleID !== 4) {
                                    survey.Sections[i].QuestionPrompts[j].QuestionScaleID = null;
                                    for (l = 0; l < survey.Sections[i].QuestionPrompts[j].QuestionScale.length; l++) {
                                        survey.Sections[i].QuestionPrompts[j].QuestionScale[l].ScaleAnswerID = null;
                                        survey.Sections[i].QuestionPrompts[j].QuestionScale[l].QuestionBranchID = null;
                                    }
                                }
                            }
                        }
                    }
                    deferred.resolve(survey);
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },

            //save partially completed survey object to DB, without finalizing
            saveSurvey: function (surveyObj, assignedSurveyID) {
                var deferred = $q.defer();
                var temp = _buildSurveySubmissionArray(surveyObj);
                var data = {
                    AssignedSurveyID: assignedSurveyID,
                    Answers: temp.answers
                };

                $http.post(_apiUrl + 'SaveSurvey', data).then(function (response) {
                    deferred.resolve(response.data);
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },

            //submit complete survey object
            //this will finalize and lock this assigned survey
            submitSurvey: function (surveyObj, assignedSurveyID) {
                var deferred = $q.defer();
                var temp = _buildSurveySubmissionArray(surveyObj);
                var data = {
                    AssignedSurveyID: assignedSurveyID,
                    Answers: temp.answers
                };
                

                $http.post(_apiUrl + 'SaveAndCommitSurvey', data).then(function (response) {
                    deferred.resolve(response.data);
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },

            //get all active surveys associated with logged in user
            getMyActiveSurveys: function () {
                var deferred = $q.defer();

                $http.get(_apiUrl + 'GetActiveSurveys').then(function (response) {
                    var outArray = [];
                    for (var i = 0; i < response.data.length; i++) {
                        var createdOn = new Date(response.data[i].CreatedOn);
                        var modifiedOn = new Date(response.data[i].ModifiedOn);
                        outArray.push({
                            assignedSurveyID: response.data[i].AssignedSurveyID,
                            surveyID: response.data[i].SurveyID,
                            surveyName: response.data[i].SurveyName,
                            surveyStatus: response.data[i].SurveyStatus,
                            surveyStatusID: response.data[i].SurveyStatusID,
                            createdOn: createdOn,
                            modifiedOn: modifiedOn
                        });
                    }
                    deferred.resolve(outArray);
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },

            //Load an Assigned Survey
            loadAssignedSurvey: function (loadSurveyObj) {
                var deferred = $q.defer(),
                    data = {
                        AssignedSurveyID: loadSurveyObj.assignedSurveyID,
                        SurveyID: loadSurveyObj.surveyID,
                        AssignedSurveyStatusID: loadSurveyObj.surveyStatusID
                    };

                $http.post(_apiUrl + 'LoadSurvey', data).then(function (response) {
                    if (response.data.AssignedSurveyID !== 0) {
                        response.data.Survey = _buildSurveyDisplayObject(response.data.Survey, response.data.Answers, true);
                        deferred.resolve(response.data);
                    }
                    else {
                        deferred.reject('User not authorized to access this quiz.');
                    }
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },

            //
            getBaseSurveys: function (grantID, directorID) {
                var deferred = $q.defer();

                $http.get(_apiUrl + 'GetBaseSurveyList?grantID=' + grantID + '&directorID=' + directorID).then(function (response) {
                    deferred.resolve(response.data);
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },


            getCuratedQuestionGroupsForCustomSurvey: function (targetID, grantID) {
                var deferred = $q.defer();

                var params = {};
                params.TargetID = targetID;
                params.GrantID = grantID;
                var config = {
                    params: params
                };

                $http.get(_apiUrl + 'GetCuratedQuestionGroupsForCustomSurvey', config).then(function (response) {
                    deferred.resolve(response.data);
                }, function(err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },

            getCuratedQuestionGroupsForAdmin: function () {
                var deferred = $q.defer();

                $http.get(_apiUrl + 'GetCuratedQuestionGroupsForAdmin').then(function (response) {
                    deferred.resolve(response.data);
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },

            loadCuratedQuestionGroup: function(id) {
                var deferred = $q.defer();
                $http.get(_apiUrl + 'LoadCuratedQuestionGroup/' + id).then(function (response) {
                    deferred.resolve(_buildSurveyDisplayObject({Sections:[response.data]}, [], false).Sections[0]);
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },

            updateCuratedQuestionGroupStatus: function(sectionID, toStatusID) {
                
                var deferred = $q.defer();

                var updateId = {
                    SectionID: sectionID,
                    CuratedQuestionStatusID: toStatusID
                };

                $http.post(_apiUrl + 'UpdateCuratedQuestionGroupStatus', updateId).then(function (response) {
                    deferred.resolve(response.data);
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },

            getTargets: function() {
                return $http.get(_apiUrl + 'GetTargets')
                    .then(function(response) {
                        if (!response) {
                            return null;
                        }
                        return response.data;
                    }, function(err) {
                        return null;
                    });
            },

            // Wrap loaded survey questions in object with additional properties for the UI
            parseQuestionPrompts: function (promptArray) {
                var outputArray = [];
                var inputArray = angular.copy(promptArray); // Don't want to modify the promptArray accidentally with pointers, make a copy to work with
                var tempObj = {};
                for (var i = 0; i < inputArray.length; i++) {
                    if (inputArray[i].hasOwnProperty('QuestionPromptID')) { // it's a matrix
                        tempObj = {
                            description: inputArray[i].Questions[0].QuestionLabel,
                            type: 'Matrix',
                            typeID: 0,
                            details: inputArray[i],
                            getID: function (index) { return this.details.Questions[index].QuestionID || this.details.Questions[index].tempID; }
                        };
                        for (var j = 0; j < tempObj.details.Questions.length; j++) {
                            tempObj.details.Questions[j].tempID = null;
                            var questionScales = tempObj.details.Questions[j].QuestionScale;
                            for (var k = 0; k < questionScales.length; k++) {
                                questionScales[k].tempID = null;
                                questionScales[k].getID = function () { return this.ScaleAnswerID || this.tempID; };
                                questionScales[k].QuestionBranch = { QuestionBranchID: questionScales[k].QuestionBranchID, TempBranchID: null, getID: function () { return this.QuestionBranchID || this.TempBranchID; } };
                            }
                            // If it has existing question branch logic, need to add a getID method to those scale answers
                            for (var m = 0; m < tempObj.details.Questions[j].QuestionBranches.length; m++) {
                                for (var n = 0; n < tempObj.details.Questions[j].QuestionBranches[m].ParentQuestions.length; n++) {
                                    for (var o = 0; o < tempObj.details.Questions[j].QuestionBranches[m].ParentQuestions[n].ScaleAnswers.length; o++) {
                                        tempObj.details.Questions[j].QuestionBranches[m].ParentQuestions[n].ScaleAnswers[o].getID = function () { return this.ScaleAnswerID || this.tempID; };
                                        tempObj.details.Questions[j].QuestionBranches[m].ParentQuestions[n].ScaleAnswers[o].QuestionBranch = { QuestionBranchID: tempObj.details.Questions[j].QuestionBranches[m].ParentQuestions[n].ScaleAnswers[o].QuestionBranchID, TempBranchID: null, getID: function () { return this.QuestionBranchID || this.TempBranchID; } };                                  
                                    }
                                }
                            }
                        }
                    }
                    else {
                        tempObj = {
                            description: inputArray[i].QuestionLabel,
                            type: inputArray[i].QuestionType,
                            typeID: inputArray[i].QuestionTypeID,
                            details: inputArray[i],
                            getID: function () { return this.details.QuestionID || this.details.tempID; }
                        };
                        tempObj.details.tempID = null;
                        
                        var questionScale = tempObj.details.QuestionScale;
                        for (var l = 0; l < questionScale.length; l++) {
                            questionScale[l].tempID = null;
                            questionScale[l].getID = function () { return this.ScaleAnswerID || this.tempID; };
                            questionScale[l].QuestionBranch = { QuestionBranchID: questionScale[l].QuestionBranchID, TempBranchID: null, getID: function () { return this.QuestionBranchID || this.TempBranchID; } };
                        }
                        //and add the default QuestionPromptID
                        tempObj.details['QuestionPromptID'] = _emptyPromptId;

                        // If it has existing question branch logic, need to add a getID method to those scale answers
                        for (var p = 0; p < tempObj.details.QuestionBranches.length; p++) {
                            for (var q = 0; q < tempObj.details.QuestionBranches[p].ParentQuestions.length; q++) {
                                for (var r = 0; r < tempObj.details.QuestionBranches[p].ParentQuestions[q].ScaleAnswers.length; r++) {
                                    tempObj.details.QuestionBranches[p].ParentQuestions[q].ScaleAnswers[r].getID = function () { return this.ScaleAnswerID || this.tempID; };
                                    tempObj.details.QuestionBranches[p].ParentQuestions[q].ScaleAnswers[r].QuestionBranch = { QuestionBranchID: tempObj.details.QuestionBranches[p].ParentQuestions[q].ScaleAnswers[r].QuestionBranchID, TempBranchID: null, getID: function () { return this.QuestionBranchID || this.TempBranchID; } };
                                }
                            }
                        }
                    }                   
                    outputArray.push(tempObj);
                }
                return outputArray;
            },

            //get composite scores for survey for editing
            getBaseCompositeScoresForEdit: function (surveyID) {
                var deferred = $q.defer();

                $http.get(_apiUrl + 'GetBaseCompositeScoresForEdit/' + surveyID).then(function (response) {
                    deferred.resolve(_buildCompositeScoreArray(response.data, []));
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },

            //get composite scores for curated questions for editing
            getCuratedCompositeScoresForEdit: function (sectionID) {
                var deferred = $q.defer();

                $http.get(_apiUrl + 'GetCuratedCompositeScoresForEdit/' + sectionID).then(function (response) {
                    deferred.resolve(_buildCompositeScoreArray(response.data, []));
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },

            getBaseQuestionsForCompositeScore: function (surveyID) {
                var deferred = $q.defer();

                $http.get(_apiUrl + 'GetBaseQuestionsForCompositeScore/' + surveyID).then(function (response) {
                    deferred.resolve(_buildCompositeScoreAllQuestionsList(response.data));
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },

            getCuratedQuestionsForCompositeScore: function (sectionID) {
                var deferred = $q.defer();

                $http.get(_apiUrl + 'GetCuratedQuestionsForCompositeScore/' + sectionID).then(function (response) {
                    deferred.resolve(_buildCompositeScoreAllQuestionsList(response.data));
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },

            parseQuestionsForCompositeScore: function (questions) {
                var outputArray = [];
                var tempObj = {};
                for (var i = 0; i < questions.length; i++) {
                    tempObj = {
                        //description: questions[i].Text,
                        details: questions[i],
                        shortDescription: questions[i].TextPlain.length > 200 ? questions[i].TextPlain.substring(0, 200) + '...' : questions[i].TextPlain,
                        selected: questions[i].Selected
                    };
                    tempObj.details['QuestionPromptID'] = _emptyPromptId;

                    outputArray.push(tempObj);
                }
                return outputArray;
            },

            // Build an array of base survey Question IDs, that should be excluded from formatted reports, 
            // for a given set of base survey sections from a custom survey
            extractExcludedBaseSurveyQuestionIDs: function(baseSurveySections) {

                var excludedBaseSurveyQuestionIDs = [];
                
                // For every section
                for (var i = 0; i < baseSurveySections.length; i++) {

                    // For every question prompt in the section
                    for (var j = 0; j < baseSurveySections[i].QuestionPrompts.length; j++) {

                        // If a matrix
                        if (baseSurveySections[i].QuestionPrompts[j].hasOwnProperty('QuestionPromptID')) {
                            for (var k = 0; k < baseSurveySections[i].QuestionPrompts[j].Questions.length; k++) {
                                // If question should be excluded
                                if (baseSurveySections[i].QuestionPrompts[j].Questions[k].ExcludeFromReports) {
                                    excludedBaseSurveyQuestionIDs.push(
                                        baseSurveySections[i].QuestionPrompts[j].Questions[k].QuestionID);
                                }
                            }

                        // If a radio or text question
                        } else {  
                            // If question should be excluded
                            if (baseSurveySections[i].QuestionPrompts[j].ExcludeFromReports) {
                                excludedBaseSurveyQuestionIDs.push(
                                    baseSurveySections[i].QuestionPrompts[j].QuestionID);
                            }
                        }

                    }
                }

                return excludedBaseSurveyQuestionIDs;

            },

            //save a custom survey to the database
            saveCustomSurvey: function (surveyObj) {
                var deferred = $q.defer();

                $http.post(_apiUrl + 'SaveCustomSurvey', surveyObj).then(function (response) {
                    if (response.data !== 0) { //success
                        deferred.resolve(response.data);
                    }
                    else {
                        deferred.reject('Server unable to save.');
                    }
                }, function () {
                    deferred.reject('Server unable to save.');
                });

                return deferred.promise;
            },

            //save a new base survey to the database
            saveBaseSurvey: function (surveyObj) {
                var deferred = $q.defer();

                $http.post(_apiUrl + 'SaveBaseSurvey', surveyObj).then(function (response) {
                    if (response.data !== 0) { //success
                        deferred.resolve(response.data);
                    }
                    else {
                        deferred.reject('Server unable to save.');
                    }
                }, function () {
                    deferred.reject('Server unable to save.');
                });

                return deferred.promise;
            },

            saveCuratedQuestionGroup: function(sectionObj) {
                var deferred = $q.defer();

                $http.post(_apiUrl + 'SaveCuratedQuestionGroup', sectionObj).then(function(response) {
                    if (response.data) {
                        deferred.resolve("Success");
                    } else {
                        deferred.reject("Server unable to save curated question");
                    }
                }, function() {
                    deferred.reject("Server unable to save curated question");
                });

                return deferred.promise;
            },

            saveBaseCompositeScores: function (compositeScores) {
                var deferred = $q.defer();

                $http.post(_apiUrl + 'SaveBaseCompositeScores', compositeScores).then(function (response) {
                    if (response.data) { 
                        deferred.resolve('Success');
                    }
                    else {
                        deferred.reject('Server unable to save composite scores.');
                    }
                }, function () {
                    deferred.reject('Server unable to save composite scores.');
                });
                return deferred.promise;
            },

            saveCuratedCompositeScores: function (compositeScores) {
                var deferred = $q.defer();

                $http.post(_apiUrl + 'SaveCuratedCompositeScores', compositeScores).then(function (response) {
                    if (response.data) {
                        deferred.resolve('Success');
                    }
                    else {
                        deferred.reject('Server unable to save composite scores.');
                    }
                }, function () {
                    deferred.reject('Server unable to save composite scores.');
                });
                return deferred.promise;
            },

            //check if a survey is editable
            isSurveyEditable: function (surveyID,ownerID) {
                var deferred = $q.defer();

                $http.get(_apiUrl + 'IsSurveyEditable?surveyID=' + surveyID + '&ownerID=' + ownerID).then(function (response) {
                    deferred.resolve(response.data);
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },
            
            //check if a base survey is editable
            isBaseSurveyEditable: function (surveyID) {
                var deferred = $q.defer();

                $http.get(_apiUrl + 'IsBaseSurveyEditable?surveyID=' + surveyID).then(function (response) {
                    deferred.resolve(response.data);
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },

            //for loading an assigned survey a user will be taking
            setSurveyParameters: function (surveyParams) {
                // surveyParams has the properties:
                // surveyID
                // assignedSurveyID
                // surveyStatusID

                //use session storage if available, if not, fall back to storage on this object (will disappear on refresh)
                if ($window.Storage) {
                    $window.sessionStorage.setItem('surveyID', surveyParams.surveyID);
                    $window.sessionStorage.setItem('assignedSurveyID', surveyParams.assignedSurveyID);
                    $window.sessionStorage.setItem('surveyStatusID', surveyParams.surveyStatusID);
                }
                else {
                    this.surveyParams = surveyParams;
                }

            },
            getSurveyParameters: function () {
                if ($window.Storage) {
                    var surveyID = $window.sessionStorage.getItem('surveyID');
                    var assignedSurveyID = $window.sessionStorage.getItem('assignedSurveyID');
                    var surveyStatusID = $window.sessionStorage.getItem('surveyStatusID');
                    return {
                        surveyID: surveyID,
                        assignedSurveyID: assignedSurveyID,
                        surveyStatusID: surveyStatusID
                    };
                }
                else {
                    return this.surveyParams;
                }
            },
            clearSurveyParameters: function () {
                if ($window.Storage) {
                    $window.sessionStorage.removeItem('surveyID');
                    $window.sessionStorage.removeItem('assignedSurveyID');
                    $window.sessionStorage.removeItem('surveyStatusID');
                }
                else {
                    this.surveyParams = {};
                }
            },
            calculateCanShowChildSection: function (section, survey) {
                return _calculateCanShowChildSection(section, survey);
            },
            getProjectsWhereUserIsAdmin: function () {
                var deferred = $q.defer();

                $http.get(ApiUrl.url('/Project/') + 'GetProjectsWhereUserIsAdmin').then(function (response) {
                    deferred.resolve(response.data);
                }, function (err) {
                    deferred.reject(err);
                });
                return deferred.promise;
            },
            getCuratedSectionTags: function () {
                var deferred = $q.defer();

                $http.get(_apiUrl + 'GetAllCuratedSectionTags').then(function (response) {
                    deferred.resolve(response.data);
                }, function (err) {
                    deferred.reject(err);
                });
                return deferred.promise;
            },
            /*-----------------------------------------------
             * 'Public' Variables constructor
             */
            surveyParams: {},
            QuestionRole: {
                Base: 1,
                Curated: 2,
                Custom: 3
            },
            CuratedSectionStatus: {
                New: 1,
                Released: 2,
                Deleted: 3
            }
        };

    }]);

angular.module('cimerFrontEndApp').factory('idFactory', function () {
    var idFactory = {};
    var _idCounter = 0;

    idFactory.getNewQuestionID = function () {
        _idCounter++;
        return 'Q' + _idCounter;
    };

    idFactory.getNewScaleAnswerID = function () {
        _idCounter++;
        return 'SA' + _idCounter;
    };

    idFactory.getNewQuestionBranchID = function () {
        _idCounter++;
        return 'QB' + _idCounter;
    };

    return idFactory;

});